<div cdkDrag [cdkDragData]="data">
  <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
  <div
    [id]="data.id"  
    class="question-area"
    [ngClass]="data.isSelected ? 'question-selected' : 'question-unselected'"
    tabindex="4" (keyup.Space)="onSelect()"
    cdkDropList
    [cdkDropListConnectedTo]="dropListIds"
    [cdkDropListData]="data.children"
    [cdkDropListEnterPredicate]="isDroppableWidget"
    (cdkDropListDropped)="onDrop($event)">
    <!-- Titlebar for Widget -->
    <div *ngIf="!isMetadataView()" class="question-top-bar"
      fxLayout="row nowrap" fxLayoutAlign="end start">
      <!-- <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">{{data.icon}}</mat-icon> -->
      <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon> 
      <img class="question-icon" src="assets/img/icons/question.png"/>
      <mat-label class="question-title" fxFlex="grow" (click)="onSelect()" 
        title="{{ data.description ? data.description : data.name }}">{{ data.seq }}. {{ data.name }}
      </mat-label>
      <mat-icon [ngStyle]="{'color': data.isOnPoint ? 'gold' : 'gray'}" 
        class="star-icon" 
        (click)="onToggleOnPointStar()" 
        title="Toggle OnPoint">{{ data.isOnPoint ? 'star' : 'star_outline' }}</mat-icon>
      <!-- <img class="img-icon" src="assets/img/questions/yes_no.png" title="Text Data Type"/> -->
      <container-element [ngSwitch]="data.typeId">  
        <img class="type-icon" *ngSwitchCase="1" src="assets/img/questions/yes_no.png"/>
        <img class="type-icon" *ngSwitchCase="2" src="assets/img/questions/year.png"/>
        <img class="type-icon" *ngSwitchCase="3" src="assets/img/questions/clock.png"/>
        <img class="type-icon" *ngSwitchCase="4" src="assets/img/questions/complex.png"/>
        <img class="type-icon" *ngSwitchCase="5" src="assets/img/questions/money.png"/>
        <img class="type-icon" *ngSwitchCase="6" src="assets/img/questions/percentage.png"/>
        <img class="type-icon" *ngSwitchCase="7" src="assets/img/questions/text.png"/>
        <img class="type-icon" *ngSwitchCase="8" src="assets/img/questions/numericnew.png" />
        <img class="type-icon" *ngSwitchDefault  src="assets/img/questions/yes_no.png"/>
      </container-element>      
      <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
      <!-- <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">expand_less</mat-icon> -->
      <!-- <mat-icon *ngIf="isMinimized" class="top-icon" (click)="onMaximize()">expand_more</mat-icon> -->
    </div>

    <!-- Config data for Widget -->
    <div *ngIf="!isMinimized" fxLayout="row nowrap">
      <app-metadata-question fxFlex="grow" [data]="tempData" (onPointQuestionToggled)="onOnPointQuestionToggled($event)"></app-metadata-question>
    </div>

    <!-- Allowed drops -->
    <div *ngIf="data.isEdit" class="question-drop-area">
      <ng-container *ngFor="let widget of data.children">
        <ng-container [ngSwitch]="widget.widgetType">
          <div appWidgetsRow
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.ROW"></div>
          <div appWidgetsField
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.FIELD"></div>
          <div appWidgetsRadio
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.RADIO"></div>
          <div appWidgetsCheckbox
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.CHECKBOX"></div>             
          <div appWidgetsInput
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.INPUT"></div>  
          <div appWidgetsTime
            [data]="$any(widget)"
            [dropListIds]="dropListIds"
            (dropListIdAdded)="onDropListIdAdded($event)"
            *ngSwitchCase="WidgetsTypeEnum.TIME_RANGE"></div>    
          <div appWidgetsText
            [data]="$any(widget)"
            *ngSwitchCase="WidgetsTypeEnum.TEXT"></div>
          <div appWidgetsArray
            [data]="$any(widget)"
            *ngSwitchCase="WidgetsTypeEnum.ARRAY"></div>
            <div appWidgetsRealtedInput
                [data]="$any(widget)"
                [dropListIds]="dropListIds"
                (dropListIdAdded)="onDropListIdAdded($event)"                    
                *ngSwitchCase="WidgetsTypeEnum.ORDINAL_IN_SET">
            </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
